import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MailIcon, LockIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    // Simulate API call
    setTimeout(() => {
      const success = login(email, password);
      if (success) {
        navigate('/profile');
      } else {
        setError('Invalid email or password');
      }
      setLoading(false);
    }, 1000);
  };
  return <main className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 flex items-center justify-center px-4 py-12" data-id="element-447">
      <div className="w-full max-w-md" data-id="element-448">
        <div className="bg-white rounded-2xl shadow-xl p-8" data-id="element-449">
          {/* Logo */}
          <div className="text-center mb-8" data-id="element-450">
            <Link to="/" className="inline-block" data-id="element-451">
              <span className="text-3xl font-bold text-blue-900 italic" data-id="element-452">
                Zinga
              </span>
              <span className="text-xs text-orange-500 block -mt-1" data-id="element-453">
                Login Creatives
              </span>
            </Link>
            <h1 className="text-2xl font-bold text-gray-900 mt-4" data-id="element-454">
              Welcome Back
            </h1>
            <p className="text-gray-600" data-id="element-455">Sign in to your account</p>
          </div>

          {error && <div className="bg-red-50 text-red-700 px-4 py-3 rounded-lg mb-6 text-sm" data-id="element-456">
              {error}
            </div>}

          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-457">
            <div data-id="element-458">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-459">
                Email Address
              </label>
              <div className="relative" data-id="element-460">
                <MailIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" data-id="element-461" />
                <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="you@example.com" required data-id="element-462" />
              </div>
            </div>

            <div data-id="element-463">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-464">
                Password
              </label>
              <div className="relative" data-id="element-465">
                <LockIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" data-id="element-466" />
                <input type={showPassword ? 'text' : 'password'} id="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-10 pr-12 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="••••••••" required data-id="element-467" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600" aria-label={showPassword ? 'Hide password' : 'Show password'} data-id="element-468">
                  {showPassword ? <EyeOffIcon className="w-5 h-5" data-id="element-469" /> : <EyeIcon className="w-5 h-5" data-id="element-470" />}
                </button>
              </div>
            </div>

            <div className="flex items-center justify-between" data-id="element-471">
              <label className="flex items-center" data-id="element-472">
                <input type="checkbox" className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" data-id="element-473" />
                <span className="ml-2 text-sm text-gray-600" data-id="element-474">Remember me</span>
              </label>
              <a href="#" className="text-sm text-blue-600 hover:text-blue-700" data-id="element-475">
                Forgot password?
              </a>
            </div>

            <button type="submit" disabled={loading} className="w-full bg-red-600 hover:bg-red-700 disabled:bg-red-400 text-white py-3 rounded-lg font-medium transition-colors" data-id="element-476">
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div className="mt-6 text-center" data-id="element-477">
            <p className="text-gray-600" data-id="element-478">
              Don't have an account?{' '}
              <Link to="/signup" className="text-blue-600 hover:text-blue-700 font-medium" data-id="element-479">
                Sign up
              </Link>
            </p>
          </div>
        </div>
      </div>
    </main>;
}